import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="absolute top-0 left-0 right-0 z-50 bg-white/10 backdrop-blur-md border-b border-white/20">
      <nav className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
              <span className="text-blue-600 font-bold text-lg">e</span>
            </div>
            <span className="text-white font-semibold text-lg">eSIM Myanmar</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-6">
            <Link to="/" className="text-white/90 hover:text-white transition-colors duration-300 text-sm font-medium">
              Home
            </Link>
            <Link to="/plans" className="text-white/90 hover:text-white transition-colors duration-300 text-sm font-medium">
              Plans
            </Link>
            <Link to="#coverage" className="text-white/90 hover:text-white transition-colors duration-300 text-sm font-medium">
              Coverage
            </Link>
            <Link to="#support" className="text-white/90 hover:text-white transition-colors duration-300 text-sm font-medium">
              Support
            </Link>
            <Link 
              to="/auth"
              className="bg-white text-blue-600 hover:bg-gray-50 font-medium py-2 px-4 rounded-lg transition-colors duration-300 text-sm"
            >
              Sign In
            </Link>
          </div>

          {/* Mobile menu button */}
          <button 
            className="md:hidden text-white"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d={isMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} 
              />
            </svg>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 pb-4">
            <div className="flex flex-col space-y-4">
              <Link 
                to="/" 
                className="text-white hover:text-gray-200 transition-colors duration-300 text-sm font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </Link>
              <Link 
                to="/plans" 
                className="text-white hover:text-gray-200 transition-colors duration-300 text-sm font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Plans
              </Link>
              <Link 
                to="#coverage" 
                className="text-white hover:text-gray-200 transition-colors duration-300 text-sm font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Coverage
              </Link>
              <Link 
                to="#support" 
                className="text-white hover:text-gray-200 transition-colors duration-300 text-sm font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                Support
              </Link>
              <Link 
                to="/auth"
                className="bg-white hover:bg-gray-100 text-blue-600 font-medium py-2 px-4 rounded-lg transition-colors duration-300 text-center text-sm"
                onClick={() => setIsMenuOpen(false)}
              >
                Sign In
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;